import { KEYS } from "@/src/const";
import type { BrokerProfileRegistrationStep, BrokerProfileStatus } from "@/src/type/brokerProfile/BrokerProfileType";

function handleBrokerIntroStatusOnLogin(profileStatus: BrokerProfileStatus | undefined, registrationStep: BrokerProfileRegistrationStep | undefined) {
  if (profileStatus === "accepted" || registrationStep === "thank-you" || registrationStep === "step3") {
    turnOffBrokerIntro();
  } else {
    keepBrokerIntro();
  }
}

function turnOffBrokerIntro() {
  localStorage.setItem(KEYS.LOCAL_STORAGE.USE_BROKER_INTRO, "false");
}

function keepBrokerIntro() {
  localStorage.setItem(KEYS.LOCAL_STORAGE.USE_BROKER_INTRO, "true");
}

export default {
  handleBrokerIntroStatusOnLogin,
  turnOffBrokerIntro,
  keepBrokerIntro,
};
